// extracted by mini-css-extract-plugin
export default {"active":"contratcts_financial_active__gnQ5m","vesselColor":"contratcts_financial_vesselColor__gOQ6n"};